/**
 * Copy text to the clipboard.
 *
 * `navigator.clipboard` is only available in secure contexts (HTTPS or localhost).
 * HTTP hosts on a LAN name fall back to `document.execCommand('copy')`.
 */
export async function copyToClipboard(text: string): Promise<void> {
    if (navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            return;
        } catch {
            // Fall through to the insecure-context fallback
        }
    }

    copyWithExecCommand(text);
}

function copyWithExecCommand(text: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.opacity = '0';
    textarea.style.pointerEvents = 'none';
    document.body.appendChild(textarea);

    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, text.length);

    let copied = false;
    try {
        copied = document.execCommand('copy');
    } finally {
        document.body.removeChild(textarea);
    }

    if (!copied) {
        throw new Error('Failed to copy text');
    }
}
